import React, { useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import styles from "../styles/Navbar.module.css";
import { Avatar, Badge, Button, Card, CardActions, CardHeader, Chip, ClickAwayListener, IconButton, Popper, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
// import pwcLogo from "../assets/newLogo.svg";
import pwcLogo from "../assets/images/pwc.svg";
import bell from "../assets/bellIcon.svg";
import { ReactComponent as PwcLogoSvg } from "assets/images/pwc-logo.svg";
import useOutsideClick from "../hooks/useOutsideClick";
import { useAuth } from "context/AuthContext";
import Notifications from "./Notification/Notification";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import { MdOutlineMenuOpen } from "react-icons/md";
import { IoMenu } from "react-icons/io5";
import { ReactComponent as NotificationIcon } from "assets/PwC_Funct_Icons_Notifications-Alert_Outline_Black_RGB.svg"
import { ReactComponent as AiIcon } from "assets/PwC_Funct_Icons_Bot_Outline_Black_RGB.svg"
import { usePermissionRedirect } from "hooks/usePermissionRedirect";
import PwcCopilot from "./pwc-Copilot/copiolot";
import { ReactComponent as PwcLogoutSvg } from "assets/logout.svg"

const Navbar = ({ menus, handleDrawer, isOpen, handleClickAway }) => {
  const buttonRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { setAuthenticated, user } = useAuth();
  const { hasPermission } = useCheckMenuPermission();
  const [profileDropdown, setProfileDropdown] = useState(false);
  useOutsideClick(buttonRef, () => setProfileDropdown(false));
  const [openNotification, setOpenNotification] = useState(false);
  const [bellElement, setBellElement] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [openAi, setOpenAi] = useState(false)
  const isMobile = useMediaQuery('(max-width:768px)');
  const { projectId } = useParams();
  const handleLogoClick = usePermissionRedirect();


  const getUserName = () => {

    const fullName = `${user?.firstName} ${user?.lastName}`;

    const parts = fullName.trim().split(" ");
    let initials = "";
    if (parts.length === 1) {
      initials = parts[0].slice(0, 2);
    } else {
      initials = parts[0][0] + parts[1][0];
    }

    return initials;
  }

  const isActive = (menu) => {
    const pathSegments = location?.pathname.split("/");
    return pathSegments[1] === menu?.toLowerCase()?.replace(/\s+/g, "-");
  };

  const handleNavigate = (menu) => {

    const selectedMenu = menus?.find(
      (m) => m?.menu?.toLowerCase() === menu?.toLowerCase()
    );

    if (selectedMenu && selectedMenu?.submenus?.length > 0) {
      navigate(`/${menu?.toLowerCase()?.replace(/\s+/g, "-")}/${selectedMenu?.submenus[0]?.route}`);
    } else {
      navigate(`/${selectedMenu?.route}`);
    }

    // if (selectedMenu && selectedMenu?.submenus?.length > 0) {
    //   navigate(
    //     `/${menu?.toLowerCase()?.replace(/\s+/g, "-")}/${selectedMenu?.submenus[0]?.route
    //     }`
    //   );
    // } else if (selectedMenu?.menu === "Projects") {
    //   navigate("/projects/project-creation/project-list");
    // }else{

    // }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("scheduleTabIndex");

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("scheduleTabIndex");
    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();
    setAuthenticated(false);
    navigate("/login");
  };

  return (
    <div className={styles.navbar} style={{ padding: isMobile && '0 10px' }}>
      <div className={styles.left}>
        {(isMobile || projectId !== undefined) && (
          menus?.filter(item => {
            const hasRoleAccess =
              item?.rolesAllowed?.some(role => user?.rolesName?.includes(role));

            if (item?.menu === "Projects") {
              return true;
            }
            return hasRoleAccess;
          })?.length > 0
          || !!projectId
        ) &&
          // <ClickAwayListener onClickAway={handleClickAway}>
          < IconButton sx={{ p: 0, paddingRight: '10px' }} onClick={handleDrawer}>
            {isOpen ? <MdOutlineMenuOpen style={{ height: '25px', width: '25px' }} /> : <IoMenu style={{ height: '25px', width: '25px' }} />}
          </IconButton>
          // </ClickAwayListener>
        }

        <div
          className={styles.logo}
          style={{
            // display: 'flex',
            // alignItems: 'center',
            // gap: '4px',
            marginTop: '4px',
            // cursor: 'pointer',
            paddingRight: '60px'
          }}
          onClick={() => {
            if (isMobile) {
              handleLogoClick();
            }
          }}
        >
          <PwcLogoSvg />
          {/* <img
            src={pwcLogo}
            alt="Project Control Manager Logo"
            style={{ width: 'auto', height: 'auto', objectFit: 'contain' }}
          />
          <span style={{ fontWeight: '400', marginTop: '-2px', fontSize: '15px', color: '#252525', lineHeight: '0px', letterSpacing: '-0.4px' }}>
            Integrated Project Control and Analytics Hub
          </span> */}
        </div>
        {
          (!isMobile) && (
            <div className={styles.menuList}>
              {menus
                ?.filter(item => {
                  const hasRoleAccess =
                    item?.rolesAllowed?.some(role => user?.rolesName?.includes(role));

                  if (item?.menu === "Projects") {
                    return true;
                  }
                  return hasRoleAccess;
                })
                ?.map(menu => (
                  <div
                    key={menu?.menu}
                    className={`${styles.menuItem} ${isActive(menu?.menu) ? styles.active : ""
                      }`}
                    style={
                      isActive(menu?.menu)
                        ? { color: theme?.customSettings?.themeColor }
                        : {}
                    }
                    onClick={() => handleNavigate(menu?.menu)}
                  >
                    <span className={styles.menuText}>{menu?.menu}</span>
                    {isActive(menu?.menu) && (
                      <div className={styles.activeUnderline}></div>
                    )}
                  </div>
                ))}
            </div>
          )
        }
      </div >
      <div className={styles.right}>
        {/* <button
          className={styles.btn}
          style={{
            background: theme?.customSettings?.themeColor,
            color: "#ffff",
          }}
        >
          App settings
        </button> */}

        {/* <div className={styles.companyLogo}>
          <div className={styles.image}>
            <img src={logo} alt="Image" />
          </div>
          <span className={styles.companyName}>Larsen & Tourbo</span>
        </div> */}
       
        <Badge
          badgeContent={notifications.filter(n => !n.isViewed).length}
          showZero
          sx={{
            gap: '10px',
            "& .MuiBadge-badge": {
              background: theme?.customSettings?.themeColor,
              color: "#fff",
              fontSize: "12px",
              lineHeight: "12px",
              top:"4px",
              right:"4px",
              fontWeight: 500,
            },
          }}
        >
          <div className={styles.ai} onClick={() => setOpenAi(prev => !prev)}>
            <AiIcon style={{ width: 30, height: 30, fill: "#696969" }} />
          </div>
          <div
            className={styles.bellLogo}
            ref={el => setBellElement(el)}
            onClick={() => setOpenNotification(prev => !prev)}
          >
            <NotificationIcon style={{ width: 30, height: 30, fill: "#696969" }} />
          </div>
        </Badge>

        <Notifications
          open={openNotification}
          anchorEl={bellElement}
          notifications={notifications}
          setNotifications={setNotifications}
          setOpenNotification={setOpenNotification}
        />

        <PwcCopilot
          open={openAi}
          setOpen={setOpenAi}
        />
        {/* <div
          className={styles.profile}
          style={{
            background: theme?.customSettings?.themeColor,
            color: "#ffff",
          }}
          onClick={() => setProfileDropdown((prev) => !prev)}
        >
          {getUserName()}
        </div> */}
        <div ref={buttonRef}>
          <div

            className={styles.profile}
            style={{
              background: theme?.customSettings?.themeColor,
              color: "#fff",
            }}
            onClick={() => setProfileDropdown((prev) => !prev)}
          >
            {getUserName()}
          </div>
          <Popper
            open={profileDropdown}
            anchorEl={buttonRef.current}
            // ref={buttonRef}
            placement="bottom-end"
            style={{ zIndex: 1200, }}
            disablePortal // <-- try this
            modifiers={[
              { name: "offset", options: { offset: [0, 8] } }
            ]}

          >
            <Card
              sx={{
                maxWidth: 300,
                borderRadius: 1,
                // boxShadow: 2,
                p: 1,
                // marginTop: '10px'
              }}
            >
              <CardHeader
                avatar={
                  <Avatar
                    sx={{
                      bgcolor: theme?.customSettings?.themeColor,
                      width: 40,
                      height: 40,
                      fontSize: "1rem",
                    }}
                    aria-label="profile"
                  >
                    {getUserName()}
                  </Avatar>
                }
                title={
                  <Typography variant="h6" fontWeight={600}>
                    {`${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim()}
                  </Typography>
                }
              // subheader={
              //   <Stack direction="row" spacing={1} flexWrap="wrap">
              //     {user?.rolesName?.map((role, ind) => {
              //       return (
              //         <Chip label={role} key={ind} size="small" />
              //       )

              //     })}
              //   </Stack>
              // }
              />
              <CardActions sx={{ justifyContent: "flex-start" }}>
                <Button fullWidth size="medium" variant="outlined" onClick={(e) => {
                  e.stopPropagation(); // prevent parent click from firing
                  handleLogout();
                }} sx={{
                  borderColor: theme?.customSettings?.themeColor,
                  color: theme?.customSettings?.themeColor,
                  textTransform: 'none'
                }}
                  endIcon={<PwcLogoutSvg style={{ width: 20, height: 20, fill: theme?.customSettings?.themeColor }} />}
                >
                  Logout
                </Button>
              </CardActions>
            </Card>
          </Popper>
        </div>
      </div>
    </div >
  );
};

export default Navbar;
